import React from "react";
import SubHeader from "../general/SubHeader";
import AvinashSri from "../../assets/member/AvinashSrivastava.jpeg";

const AvinashKumar = () => {
  return (
    <>
      <SubHeader message="Members" />

      <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>Members</span>
            <hr />
          </div>
          <p className="sec-heading">Our Management Group</p>

          <div className="member-area row mt-5">
            <div className="col-lg-4 col-12 my-3 pe-lg-0">
              <img
                src={AvinashSri}
                className="img-fluid border-0 rounded"
                alt="Agents"
              />
            </div>

            <div className="col-lg-8 col-12 my-3 text-muted">
              <div className="member-info">
                <p className="fw-bold fs-5 my-0 text-dark">
                  Avanish Kumar Srivastava
                </p>
                <span>Legal Advisor</span>
                <br />
                <p className="mt-3 para-text fw-bold">
                  Advocate
                  <br />
                  Education: M.A.L.L.B.
                  <br />
                  Experience: 15 year experience in Allahabad High court
                </p>

                <p>
                  Avanish Kumar Srivastava is an esteemed Legal Advisor and
                  Advocate with over 15 years of experience practicing law at
                  the Allahabad High Court. With his deep legal acumen, he
                  provides strategic guidance and counsel to Swalok Group,
                  ensuring the organization’s legal compliance and supporting
                  its various legal operations.
                  <br />
                  <br />
                  Avanish Kumar Srivastava is an esteemed Legal Advisor and
                  Advocate with over 15 years of experience practicing law at
                  the Allahabad High Court. With his deep legal acumen, he
                  provides strategic guidance and counsel to Swalok Group,
                  ensuring the organization’s legal compliance and supporting
                  its various legal operations.
                  <br />
                  <br />
                  Throughout his career, Avinash has handled a wide range of
                  high-profile cases, showcasing his skill in both legal
                  research and courtroom advocacy. His in-depth experience in
                  the Allahabad High Court allows him to navigate even the most
                  challenging legal landscapes with confidence.
                  <br />
                  <br />
                  <strong>
                    As a key member of the Swalok Group, Avanish Kumar
                    Srivastava continues to provide invaluable legal expertise,
                    making significant contributions to the group's growth and
                    success.
                  </strong>
                </p>
              </div>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>
    </>
  );
};

export default AvinashKumar;
